module.exports = __webpack_public_path__ + "img/icon_map_2_off_011.a7712dcb.png";